import React, { useState } from 'react'

import {
  useNavigate 
} from 'react-router-dom'

import useFirebase from 'hooks/firebase'

import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  OutlinedInput,
  TextField,
  Typography
} from '@mui/material'

import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'

// Blue 6c91c2
// Brighter blue 228cdb

const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
}

const SignIn = (props) => {
  const navigate = useNavigate()
  const { auth } = useFirebase()
  const { signInWithEmail } = auth

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const [errorEmail, setErrorEmail] = useState(false)
  const [errorEmailText, setErrorEmailText] = useState(errorEmail ? 'Email inválido' : '')
  
  const [errorPassword, setErrorPassword] = useState(false)
  const [errorPasswordText, setErrorPasswordText] = useState(errorPassword ? 'Password incorrecta' : '')
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  const signIn = async () => {
    if (!validateEmail(email)) {
      setErrorEmail(true)
      setErrorEmailText('Email inválido')
      return
    }

    const error = await signInWithEmail(email, password)
    if (error) {
      const errorCode = error.code
      if (errorCode === 'auth/invalid-email') {
        setErrorEmailText('Email inválido')
        setErrorEmail(true)
      } else if (errorCode === 'auth/user-disabled') {
        setErrorEmailText('Usuario deshabilitado')
        setErrorEmail(true)
      } else if (errorCode === 'auth/user-not-found') {
        setErrorEmailText('Usuario no encontrado')
        setErrorEmail(true)
      } else if (errorCode === 'auth/wrong-password') {
        setErrorPasswordText('Password incorrecta')
        setErrorPassword(true)
      } else {
        console.log(error)
        setErrorEmailText('Error desconocido')
        setErrorPasswordText('Error desconocido')
      }
      return
    }

    navigate('/director')
  }

  const handleEmailChanged = (event) => {
    setErrorEmail(false)
    setErrorEmailText('')
    setEmail(event.target.value)
  }

  const handlePasswordChanged = (event) => {
    setErrorPassword(false)
    setErrorPasswordText('')
    setPassword(event.target.value)
  }

  return (
    <Grid container alignItems='center' spacing={0} style={{ backgroundImage: `url('/assets/images/main_background.png')`, backgroundRepeat: 'repeat', backgroundSize: 'cover' }} sx={{ minHeight: '100vh' }}>
      <Grid item xs={12}>
        <Container maxWidth='sm'>
          <Card sx={{ p: 2, bgcolor: 'transparent' }}>
            <CardContent>
              <Grid container spacing={3}>
                {/* <Grid item xs={12}>
                  <Typography variant='h4' gutterBottom>
                    Inicia sesión
                  </Typography>
                </Grid> */}
                <Grid item xs={12} align='center'>
                  <Box
                    component='img'
                    src='/assets/images/lightspot_logo_dark.png'
                    sx={{ width: '30%' }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    error={errorEmail}
                    helperText={errorEmailText}
                    id='outlined-email-input'
                    // InputLabelProps={{ shrink: true }}
                    // label='Email'
                    value={email}
                    onChange={handleEmailChanged}
                    placeholder='Ingresa tu email'
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth variant='outlined'>
                    {/* <InputLabel htmlFor='outlined-password'>Password</InputLabel> */}
                    <OutlinedInput
                      id='outlined-password'
                      type={showPassword ? 'text' : 'password'}
                      value={password}
                      onChange={handlePasswordChanged}
                      error={errorPassword}
                      // helperText={errorPasswordText}
                      placeholder='6+ caracteres'
                      notched
                      endAdornment={
                        <InputAdornment position='end'>
                          <IconButton
                            aria-label='toggle password visibility'
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge='end'
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      // label='Password'
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Typography  variant='body1' textAlign='end'>
                    <Link color='text.secondary' sx={{ textDecoration: 'none' }} href='/olvide'><i>¿Olvidaste tu contraseña?</i></Link>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Grid container direction='row' justifyContent='center'>
                    <Button color='lightGreen' variant='contained' disableElevation size='large' onClick={() => signIn()}>
                      <b style={{ fontSize: 16, fontWeight: 800 }}>Iniciar sesión</b>
                    </Button>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                  <Grid container spacing={2} sx={{ pt: 2 }}>
                    <Grid item xs={12}>
                      <Button
                        disableElevation
                        fullWidth
                        onClick={() => googleSignIn()}
                        size='large'
                        startIcon={<GoogleIcon />}
                        sx={{
                          background: '#373f470a', 
                          color: '#444'
                        }}
                      >
                        Continuar con Google
                      </Button>
                    </Grid>
                  </Grid>
                </Grid> */}
                {/* <Grid item xs={12}>
                  <Typography sx={{ pt: 4 }} variant='body1'>
                    ¿No tienes una cuenta? <Link sx={{ fontWeight: 'bolder', textDecoration: 'none' }} href='/registro'>Regístrate</Link>
                  </Typography>
                </Grid> */}
              </Grid>
            </CardContent>
          </Card>
        </Container>
      </Grid>
    </Grid>
  )
}

export default SignIn